import script from "./ViewPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPermissions.vue?vue&type=script&setup=true&lang=js"

import "./ViewPermissions.vue?vue&type=style&index=0&id=0f973c99&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f973c99"]])

export default __exports__